<div style="height: 88vh;">
	<mat-toolbar>
		<mat-toolbar-row>
			<button mat-icon-button (click)="sidenav.toggle()" fxShow="true" fxHide.gt-sm>
        <i class="icon ion-md-menu"></i>
      </button>
      <span routerLink="/"  style="color: indigo;">Topcrew Aviation</span>
      <span class="menu-spacer"></span>
      <div fxShow="true" fxHide.lt-md fxLayoutGap="10px">
        <a  href="https://wa.me/9180944 49995" target="_blank" mat-button>24 X 7<i  class="ion-logo-whatsapp"></i></a>
        <!-- The following menu items will be hidden on both SM and XS screen sizes -->
        <a routerLink="/" mat-button>Home</a>
        <a routerLink="/eligibility" mat-button>Selection Process</a>
        <!-- <a routerLink="/training" mat-button>Training</a> -->
        <a routerLink="/courses" mat-button>Courses</a>
        <a routerLink="/faq" mat-button>FAQs</a>
        <a routerLink="/team" mat-button>About Us</a>
        <a routerLink="/apply" mat-stroked-button class="apply-btn">Apply Now</a>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container fxFlexFill>
    <mat-sidenav #sidenav mode="over">
      <mat-list (click)="sidenav.toggle()">
        <!-- <a (click)="sidenav.toggle()" href="" mat-list-item>Close</a> -->
        <mat-list-item><a  href="https://wa.me/9180944 49995" target="_blank" mat-button>24 X 7<i  class="ion-logo-whatsapp"></i></a></mat-list-item>
        <mat-list-item><a routerLink="/" mat-button>Home</a></mat-list-item>
        <mat-list-item><a routerLink="/eligibility" mat-button>Selection Process</a></mat-list-item>
        <!-- <mat-list-item><a routerLink="/training" mat-button>Training</a></mat-list-item> -->
        <mat-list-item><a routerLink="/courses" mat-button>Courses</a></mat-list-item>
        <mat-list-item><a routerLink="/faq" mat-button>FAQs</a></mat-list-item>
        <mat-list-item><a routerLink="/team" mat-button>About Us</a></mat-list-item>
        <mat-list-item><a routerLink="/apply" mat-stroked-button color="warn">Apply Now</a></mat-list-item>
      </mat-list>
    </mat-sidenav>
    <mat-sidenav-content fxFlexFill> 
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>